function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Text } from "sprout-ui-primitives";
import styled from "styled-components";
import { ItemType } from "sprout-graphql";
import { BreadcrumbsPseudo } from "sprout-ui-dom/dist/Breadcrumbs";
import { themeGet, media } from "sprout-ui-theme";
import Avatar from "../Avatar";
import ItemImage from "../ItemImage";
import { CardLink } from "../Card";
export const SearchItemWrapper = styled("div")`
  position: relative;

  &[aria-selected="true"] {
    background: ${themeGet("colors.black.4")};
  }

  &:active {
    background: ${themeGet("colors.black.12")};
  }
`;
const SearchItemBreadcrumbsPseudo = styled(BreadcrumbsPseudo)`
  color: ${themeGet("colors.black.60")};

  margin-bottom: 2px;
`;
const StyledItemImage = styled(ItemImage)`
  flex: none;
  margin-right: 16px;
`;
const StyledBox = styled(Box)`
  position: relative;
  pointer-events: none;

  a {
    pointer-events: auto;
  }
`;
const StyledText = styled(Text)`
  font-size: ${themeGet("fontSizes.2")}px;

  ${media.up("medium", "pointer")} {
    font-size: ${themeGet("fontSizes.1")}px;
  }
`;
const SearchItem = (props)=>{
    const { owner , label , type , image , url , rootTopic , parentTopic  } = props, rest = _objectWithoutProperties(props, [
        "owner",
        "label",
        "type",
        "image",
        "url",
        "rootTopic",
        "parentTopic"
    ]);
    const rootOwner = rootTopic === null || rootTopic === void 0 ? void 0 : rootTopic.owner;
    return /*#__PURE__*/ _jsxs(SearchItemWrapper, _objectSpread({}, rest, {
        children: [
            /*#__PURE__*/ _jsx(CardLink, {
                to: url
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                alignItems: "center",
                p: "8px 16px",
                children: [
                    owner && /*#__PURE__*/ _jsx(Box, {
                        mr: "16px",
                        flex: "none",
                        children: /*#__PURE__*/ _jsx(Avatar, {
                            user: owner,
                            size: 36,
                            navigable: true
                        })
                    }),
                    type && [
                        ItemType.Post,
                        ItemType.Topic
                    ].includes(type) && /*#__PURE__*/ _jsx(StyledItemImage, {
                        type: type,
                        size: 36,
                        src: image || undefined
                    }),
                    /*#__PURE__*/ _jsxs(StyledBox, {
                        flex: "auto",
                        minWidth: "0",
                        children: [
                            rootOwner && rootTopic && parentTopic && /*#__PURE__*/ _jsx(SearchItemBreadcrumbsPseudo, {
                                showTeam: false,
                                owner: rootOwner,
                                parentTopic: parentTopic,
                                rootTopic: rootTopic,
                                renderAsLink: true
                            }),
                            /*#__PURE__*/ _jsx(StyledText, {
                                truncate: true,
                                fontWeight: type === ItemType.Post ? "regular" : "bold",
                                color: !label && type === ItemType.Post ? "black.24" : "black.87",
                                lineHeight: "initial",
                                children: label
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
export default SearchItem;
